import { TokenType } from "../odata-types.ts";
import { Expression } from "./base/Expression.ts";
import { joinPath, parsePath, pathToPropertyInfo } from "./base/types.ts";
import type { FilterExpression, PropertyInfo } from "./base/types.ts";

export class LambdaExpression extends Expression {
    readonly type = "lambda";
    public operator: typeof TokenType.ANY | typeof TokenType.ALL;
    public readonly collectionPath: string[];
    public variable?: string;
    public predicate?: FilterExpression;

    constructor(
        operator: typeof TokenType.ANY | typeof TokenType.ALL,
        collectionPath: string[] | string,
        variable?: string,
        predicate?: FilterExpression
    ) {
        super();
        this.operator = operator;
        this.collectionPath = parsePath(collectionPath);
        this.variable = variable;
        this.predicate = predicate;

        // Validate: 'all' requires parameters
        if (operator === TokenType.ALL && (!variable || !predicate)) {
            throw new Error("'all' operator requires parameters");
        }
    }

    toPathString(): string {
        return joinPath(this.collectionPath);
    }

    stringify(): string {
        const collection = this.toPathString();

        if (!this.variable || !this.predicate) {
            return `${collection}/${this.operator}()`;
        }

        return `${collection}/${this.operator}(${this.variable}: ${this.predicate.stringify()})`;
    }

    isParameterless(): boolean {
        return !this.variable || !this.predicate;
    }

    getKey(): string {
        const collection = this.toPathString();

        if (!this.predicate) {
            return `eq::${collection}::exists`;
        }

        return `${this.operator}::${collection}::${this.predicate.getKey()}`;
    }

    getPropertyInfo(): PropertyInfo {
        return pathToPropertyInfo(this.collectionPath);
    }
}
